// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".staylio-install-base-bar-chart .svg_select_points{display:none !important}.staylio-install-base-bar-chart .monthly-manual-select{max-height:40px}.staylio-install-base-bar-chart .monthly-manual-select fieldset{margin-bottom:0}.staylio-install-base-widget-tooltip{padding:4px;font-size:10px;font-weight:bold;line-height:1;color:#373d3f}.staylio-install-base-widget-tooltip>span{padding:0}", ""]);
// Exports
module.exports = exports;
